module.exports = __webpack_public_path__ + "static/img/注意高温.99b6a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/注意高温.png
// module id = KBBu
// module chunks = 1